// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"725":"components-tabs","787":"index2"}[chunkId] || chunkId) + "." + {"269":"caa419ff","725":"7f0084e7","787":"98c13c16","876":"db9718dd"}[chunkId] + ".js";
};